import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const UnitedStatesFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_16172'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_16172)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M20 0H0V0.933333H20V0ZM20 1.86667H0V2.8H20V1.86667ZM0 3.73333H20V4.66667H0V3.73333ZM20 5.6H0V6.53333H20V5.6ZM0 7.46667H20V8.4H0V7.46667ZM20 9.33333H0V10.2667H20V9.33333ZM0 11.2H20V12.1333H0V11.2ZM20 13.0667H0V14H20V13.0667Z'
					fill='#D02F44'
				/>
				<rect
					width='8.57143'
					height='6.53333'
					fill='#46467F'
				/>
				<g filter='url(#filter0_d_2332_16172)'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M1.90551 1.40002C1.90551 1.65775 1.69231 1.86668 1.42932 1.86668C1.16632 1.86668 0.953125 1.65775 0.953125 1.40002C0.953125 1.14228 1.16632 0.93335 1.42932 0.93335C1.69231 0.93335 1.90551 1.14228 1.90551 1.40002ZM3.81027 1.40002C3.81027 1.65775 3.59707 1.86668 3.33408 1.86668C3.07108 1.86668 2.85789 1.65775 2.85789 1.40002C2.85789 1.14228 3.07108 0.93335 3.33408 0.93335C3.59707 0.93335 3.81027 1.14228 3.81027 1.40002ZM5.23884 1.86668C5.50183 1.86668 5.71503 1.65775 5.71503 1.40002C5.71503 1.14228 5.50183 0.93335 5.23884 0.93335C4.97585 0.93335 4.76265 1.14228 4.76265 1.40002C4.76265 1.65775 4.97585 1.86668 5.23884 1.86668ZM7.61979 1.40002C7.61979 1.65775 7.40659 1.86668 7.1436 1.86668C6.88061 1.86668 6.66741 1.65775 6.66741 1.40002C6.66741 1.14228 6.88061 0.93335 7.1436 0.93335C7.40659 0.93335 7.61979 1.14228 7.61979 1.40002ZM2.3817 2.80002C2.64469 2.80002 2.85789 2.59108 2.85789 2.33335C2.85789 2.07562 2.64469 1.86668 2.3817 1.86668C2.1187 1.86668 1.90551 2.07562 1.90551 2.33335C1.90551 2.59108 2.1187 2.80002 2.3817 2.80002ZM4.76265 2.33335C4.76265 2.59108 4.54945 2.80002 4.28646 2.80002C4.02347 2.80002 3.81027 2.59108 3.81027 2.33335C3.81027 2.07562 4.02347 1.86668 4.28646 1.86668C4.54945 1.86668 4.76265 2.07562 4.76265 2.33335ZM6.19122 2.80002C6.45421 2.80002 6.66741 2.59108 6.66741 2.33335C6.66741 2.07562 6.45421 1.86668 6.19122 1.86668C5.92823 1.86668 5.71503 2.07562 5.71503 2.33335C5.71503 2.59108 5.92823 2.80002 6.19122 2.80002ZM7.61979 3.26668C7.61979 3.52442 7.40659 3.73335 7.1436 3.73335C6.88061 3.73335 6.66741 3.52442 6.66741 3.26668C6.66741 3.00895 6.88061 2.80002 7.1436 2.80002C7.40659 2.80002 7.61979 3.00895 7.61979 3.26668ZM5.23884 3.73335C5.50183 3.73335 5.71503 3.52442 5.71503 3.26668C5.71503 3.00895 5.50183 2.80002 5.23884 2.80002C4.97585 2.80002 4.76265 3.00895 4.76265 3.26668C4.76265 3.52442 4.97585 3.73335 5.23884 3.73335ZM3.81027 3.26668C3.81027 3.52442 3.59707 3.73335 3.33408 3.73335C3.07108 3.73335 2.85789 3.52442 2.85789 3.26668C2.85789 3.00895 3.07108 2.80002 3.33408 2.80002C3.59707 2.80002 3.81027 3.00895 3.81027 3.26668ZM1.42932 3.73335C1.69231 3.73335 1.90551 3.52442 1.90551 3.26668C1.90551 3.00895 1.69231 2.80002 1.42932 2.80002C1.16632 2.80002 0.953125 3.00895 0.953125 3.26668C0.953125 3.52442 1.16632 3.73335 1.42932 3.73335ZM2.85789 4.20002C2.85789 4.45775 2.64469 4.66668 2.3817 4.66668C2.1187 4.66668 1.90551 4.45775 1.90551 4.20002C1.90551 3.94228 2.1187 3.73335 2.3817 3.73335C2.64469 3.73335 2.85789 3.94228 2.85789 4.20002ZM4.28646 4.66668C4.54945 4.66668 4.76265 4.45775 4.76265 4.20002C4.76265 3.94228 4.54945 3.73335 4.28646 3.73335C4.02347 3.73335 3.81027 3.94228 3.81027 4.20002C3.81027 4.45775 4.02347 4.66668 4.28646 4.66668ZM6.66741 4.20002C6.66741 4.45775 6.45421 4.66668 6.19122 4.66668C5.92823 4.66668 5.71503 4.45775 5.71503 4.20002C5.71503 3.94228 5.92823 3.73335 6.19122 3.73335C6.45421 3.73335 6.66741 3.94228 6.66741 4.20002ZM7.1436 5.60002C7.40659 5.60002 7.61979 5.39108 7.61979 5.13335C7.61979 4.87562 7.40659 4.66668 7.1436 4.66668C6.88061 4.66668 6.66741 4.87562 6.66741 5.13335C6.66741 5.39108 6.88061 5.60002 7.1436 5.60002ZM5.71503 5.13335C5.71503 5.39108 5.50183 5.60002 5.23884 5.60002C4.97585 5.60002 4.76265 5.39108 4.76265 5.13335C4.76265 4.87562 4.97585 4.66668 5.23884 4.66668C5.50183 4.66668 5.71503 4.87562 5.71503 5.13335ZM3.33408 5.60002C3.59707 5.60002 3.81027 5.39108 3.81027 5.13335C3.81027 4.87562 3.59707 4.66668 3.33408 4.66668C3.07108 4.66668 2.85789 4.87562 2.85789 5.13335C2.85789 5.39108 3.07108 5.60002 3.33408 5.60002ZM1.90551 5.13335C1.90551 5.39108 1.69231 5.60002 1.42932 5.60002C1.16632 5.60002 0.953125 5.39108 0.953125 5.13335C0.953125 4.87562 1.16632 4.66668 1.42932 4.66668C1.69231 4.66668 1.90551 4.87562 1.90551 5.13335Z'
						fill='url(#paint0_linear_2332_16172)'
					/>
				</g>
			</g>
			<defs>
				<filter
					id='filter0_d_2332_16172'
					x='0.953125'
					y='0.93335'
					width='6.66602'
					height='5.66663'
					filterUnits='userSpaceOnUse'
					colorInterpolationFilters='sRGB'>
					<feFlood
						floodOpacity='0'
						result='BackgroundImageFix'
					/>
					<feColorMatrix
						in='SourceAlpha'
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
						result='hardAlpha'
					/>
					<feOffset dy='1' />
					<feColorMatrix
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0'
					/>
					<feBlend
						mode='normal'
						in2='BackgroundImageFix'
						result='effect1_dropShadow_2332_16172'
					/>
					<feBlend
						mode='normal'
						in='SourceGraphic'
						in2='effect1_dropShadow_2332_16172'
						result='shape'
					/>
				</filter>
				<linearGradient
					id='paint0_linear_2332_16172'
					x1='0.953125'
					y1='0.93335'
					x2='0.953125'
					y2='5.60002'
					gradientUnits='userSpaceOnUse'>
					<stop stopColor='white' />
					<stop
						offset='1'
						stopColor='#F0F0F0'
					/>
				</linearGradient>
			</defs>
		</svg>
	);
};

export default UnitedStatesFlagIcon;
